import { gql } from '@apollo/client';

export const GET_NOISE_EVENTS_BY_ALERT_ID_RESOURCE_GROUPS = gql(`
  query GetNoiseEventsByAlertIdResourceGroups($filter: GuidIdInFilter) {
    facility {
      alerts {
        noiseEvents(filter: $filter) {
          id
          noiseEventPolicyOverride {
            resourceGroupId
            override
          }
        }
      }
    }
  }
`);
